export { default as useContentfulRichTextRendererOptions } from './useContentfulRichTextRendererOptions';
